import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import IcoImg from "./assets/img/Ico.png";
const Solutions = () => {
    return (
        <>
            <Header></Header>
            <div className="mainContent">
                <div className="bannerWrap innerBanner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-9">
                                <div className="titleWrap">
                                    <h2>Hummingtec: Your Technology Partner</h2>
                                    <p>Hummingtec has worked with over 45 startups to help them achieve their goals. From the conception and validation of the idea until the product is built and ready to roll out, Hummingtec caters to the needs of a startup and provides all the services needed to be successful.</p>
                                    <p>We offer you guidance and resources that will help you increase your valuation and reduce your overhead costs. As Technology Partners, we join hands in your growth and success story by enabling you to focus on your goals and GTM strategy, building networks while we transform your ideas into a crisp market-ready product and handle the monthly payroll, team management, quality checks, and deliver before the deadline.</p>
                                    <a href="#">Learn More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="crmServListWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="titleWrap">
                                    <h2>Elevate Your Business with Our Expert Software Solutions!</h2>
                                    <p>Technical Mastery at Your Fingertips.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Expert Software Developers</h2>
                                        <p>Imagine having a world-className virtual software team at your command. Scale up or down effortlessly, meeting project deadlines without the hassle of hiring. We bring the best in the business to you!</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Cutting-Edge Development Tools</h2>
                                        <p>Dive into innovation with our suite of development environments and tools. Whether it’s GitHub, Bitbucket, or other specialized tools, we've got the tech stack to bring your vision to life.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Cloud Services Revolution</h2>
                                        <p>Leverage the power of top-tier cloud platforms like AWS, Azure, or Google Cloud. We offer the ultimate solution for hosting, scalability, and high-performance computing needs.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>DevOps Excellence</h2>
                                        <p>Streamline your deployment with our CI/CD tools, containerization expertise (think Docker), and orchestration finesse (hello, Kubernetes). Efficiency is just a click away.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Assured Quality with QA Tools</h2>
                                        <p>Our automated testing frameworks guarantee top-notch quality. From unit to user acceptance testing, we ensure every aspect of your software shines.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Fortified Security</h2>
                                        <p>Safeguard your digital assets with our robust security tools. Code analysis, encryption, and data protection are our fortresses against cyber threats.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Smart Data Solutions</h2>
                                        <p>Our data storage and management solutions, encompassing both SQL and NoSQL, are designed for efficiency and power.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Insightful Analytics and Monitoring</h2>
                                        <p>Transform data into decisions with our analytics tools. Monitor application performance and user engagement to stay ahead of the curve.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>UI/UX Design Brilliance</h2>
                                        <p>Create captivating user experiences with our UI/UX design tools – because your users deserve the best.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>API and Integration Expertise</h2>
                                        <p>Seamlessly integrate with other software and services through our expertly developed APIs.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Mobile Development Prowess</h2>
                                        <p>Enter the mobile arena with our iOS and Android development platforms, tailored for today’s on-the-go users.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="crmServListWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="titleWrap">
                                    <h2>Elevate Your Business with Our Expert Software Solutions!</h2>
                                    <p>Operational Brilliance for Unmatched Growth.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Strategic Business Planning</h2>
                                        <p>Navigate your business journey with our clear models, market analysis, and strategic insights.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Financial Management Simplified</h2>
                                        <p>Keep your finances in check with our comprehensive tools for tracking, forecasting, and managing your fiscal responsibilities.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>HR Management Made Easy</h2>
                                        <p>From recruitment to payroll, our HR tools streamline employee management, so you can focus on growth.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Project Management and Collaboration</h2>
                                        <p>Enhance team synergy with tools like Trello, Asana, or Jira – because great collaboration breeds innovation.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>CRM for Customer Success</h2>
                                        <p>Manage customer interactions and sales effortlessly with our dynamic CRM systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Marketing and Branding Genius</h2>
                                        <p>Elevate your brand with our digital marketing tools and creative strategies.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Legal and Compliance Clarity</h2>
                                        <p>Navigate the complexities of legal requirements and industry compliance with confidence.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Sales and Distribution Network</h2>
                                        <p>Establish powerful channels for software distribution and sales, tailored to your unique needs.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Corporate Governance and Structure</h2>
                                        <p>Build a solid foundation with our governance and structural strategies.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Network and Partnerships</h2>
                                        <p>Join our network of partners and industry experts for unparalleled support and collaboration.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Exceptional Customer Support Systems</h2>
                                        <p>Deliver outstanding customer service with our comprehensive support systems.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="itemWrap">
                                    <div className="icoWrap">
                                        <img src={IcoImg} className="img-fluid" alt="" />
                                    </div>
                                    <div className="dataWrap">
                                        <h2>Scalability Strategies</h2>
                                        <p>Plan for the future with our scalability insights, ensuring your business grows seamlessly.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </>
    );
}
export default Solutions;